import type { C1_Button } from "../model/C1_Button";
import { ChannelType } from "../../../src/models/ChannelType";
import type { DisplayFunction, RockerRowConfig } from "./GlasButtonFrontView";

/** Ghost buttons retain their parent group as owner, which has no button API. */
export function getC1ButtonDevice(button: C1_Button) {
  const owner = button.owner;
  return typeof owner?.getButtonChannel === "function" && typeof owner?.isButtonRowSplit === "function"
    ? owner : undefined;
}

/** Reads one visible area's label and function from its current ESTADA channel. */
function buttonAreaFunction(button: C1_Button, rowIndex: number, buttonIndex: number): DisplayFunction {
  const channel = getC1ButtonDevice(button)?.getButtonChannel(rowIndex, buttonIndex);
  return {
    channelType: channel?.channelType ?? ChannelType.Unknown,
    name: channel?.name ?? "",
  };
}

/** Produces a detached row snapshot shared by plan, roombook and PDF renderers. */
export function getC1ButtonRows(button: C1_Button): RockerRowConfig[] {
  const device = getC1ButtonDevice(button);
  if (!device?.baseProps) {
    return [{ mode: "shared", shared: { channelType: ChannelType.Unknown, name: "" } }];
  }
  const rows: RockerRowConfig[] = [];
  for (let rowIndex = 0; rowIndex < (device.baseProps.buttonBaseProps?.numberOfButtonRows ?? 1); rowIndex += 1) {
    if (device.isButtonRowSplit(rowIndex)) {
      rows.push({
        mode: "split",
        left: buttonAreaFunction(button, rowIndex, 0),
        right: buttonAreaFunction(button, rowIndex, 1),
      });
    } else {
      rows.push({ mode: "shared", shared: buttonAreaFunction(button, rowIndex, 0) });
    }
  }
  return rows;
}
